module.exports = __webpack_public_path__ + "img/评估中心背景_3.2a18ffb1.png";